import React from 'react';
import { EnrollmentPeriod } from 'types/enrollmentService';
import { observer } from 'mobx-react-lite';
import {
  getProductLinesFromArray,
  sortByProductLineId,
} from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import CommonEnrollmentCard from 'components/group-info/CommonEnrollmentCard';
import { useHistory } from 'react-router-dom';
import { createStyles } from './styles';

interface EStoreEnrollmentCardsSectionProps {
  cardsList: EnrollmentPeriod[];
  isSubscriberElected?: boolean;
}

const EStoreEnrollmentCardsSection: React.FC<EStoreEnrollmentCardsSectionProps> = observer(
  ({ cardsList, isSubscriberElected = false }) => {
    const classes = createStyles();
    const history = useHistory();

    const redirectToProposal = (enrollmentPeriod: EnrollmentPeriod): void => {
      const eStoreEnrollProposal = enrollmentPeriod?.proposals.find((proposal) => proposal?.preferred) || null;

      if (eStoreEnrollProposal) {
        history.push(
          `/proposal-v2/${enrollmentPeriod.id}?cartId=${eStoreEnrollProposal.cartId}&groupId=${enrollmentPeriod.groupId}`,
        );
      }
    };

    // Only 1 proposal can have preferred set to true
    const QuoteEnrollment = (enrollmentPeriod: EnrollmentPeriod): JSX.Element => {
      const ProposalDetails = enrollmentPeriod.proposals
        .filter(({ preferred }) => preferred)
        .map((proposal) => {
          const sortedProductLines = proposal.productLines.sort((a, b) => {
            return sortByProductLineId(a.id, b.id);
          });
          return (
            <li key={proposal.cartId}>
              <div className={classes.proposalDetailsRecord}>
                <span className={classes.proposalDetailKey}>Products: </span>
                <span className={classes.productLineValue}>
                  {getProductLinesFromArray(sortedProductLines.map(({ id }) => id))}
                </span>
              </div>
            </li>
          );
        });

      return <ul className={classes.proposalDetailsSection}>{ProposalDetails}</ul>;
    };

    return (
      <section className={classes.section}>
        {cardsList.length > 0 && <h3 className={classes.sectionTitle}>My quote</h3>}
        <div className={classes.proposalsCardWrapper}>
          {cardsList.map((enrollmentPeriod) => (
            <CommonEnrollmentCard
              key={enrollmentPeriod.id}
              enrollmentPeriod={enrollmentPeriod}
              onContinue={(): void => redirectToProposal(enrollmentPeriod)}
              footer={QuoteEnrollment(enrollmentPeriod)}
              type="ee"
              isSubscriberElected={isSubscriberElected}
            />
          ))}
        </div>
      </section>
    );
  },
);

export default EStoreEnrollmentCardsSection;
